import * as React from 'react';
import { ButtonProps } from './Button.types';

export const Button = ({
    href,
    onClick,
    children,
    secondary,
    className,
    type, 
    ref,
}: ButtonProps): JSX.Element => {
    const onClickHandler = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if(!href) e.preventDefault();
        onClick(e);
    };

    return (
        <>
            {type === 'submit' ? (
                <button
                    type={type}
                    className={`
                        btn 
                        ${className ? className : ''}
                        ${secondary !== true ? `cta` : ''}
                    `}
                >
                    {children}
                </button>
            ) : (
                <a
                    href={href ? href : `#`}
                    onClick={onClickHandler}
                    className={`
                        btn 
                        ${className ? className : ''}
                        ${secondary !== true ? `cta` : ''}
                    `}
                    ref={ref}
                >
                    {children}
                </a>
            )}
        </>
        
    )
};